import { jwtDecode } from "jwt-decode";

const TOKEN_KEY = "authToken"; // token name

/**
 * Decode JWT token.
 *
 * @param {string} token Token to decode.
 *
 * @return {Object} Decoded token object.
 */
export const decodeToken = (token) => {
  try {
    return jwtDecode(token);
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
};

const EXPIRATION_KEY = "tokenExpiration";

/**
 * Get JWT token in local storage.
 *
 * @param {string} token Token to set.
 */
export const setToken = (token) => {
  const expirationTime = Date.now() + 24 * 60 * 60 * 1000; // 1 day is 24 * 60 * 60 * 1000
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EXPIRATION_KEY, expirationTime.toString());
};

/**
 * Get JWT token decoded from local storage.
 *
 * @return {Object} The decoded token.
 */
export const getToken = () => {
  const expirationTime = parseInt(localStorage.getItem(EXPIRATION_KEY), 10);
  if (Date.now() > expirationTime) {
    removeToken();
    return null;
  }
  return localStorage.getItem(TOKEN_KEY);
};

/**
 * Remove token from local storage.
 */
export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRATION_KEY);
};

/**
 * Check if JWT token expired.
 *
 * @param {string} token Token to check.
 *
 * @return {boolean} True if token expired otherwise return false.
 */
export const isTokenExpired = () => {
  const expirationTime = parseInt(localStorage.getItem(EXPIRATION_KEY), 10);
  return Date.now() > expirationTime;
};
